const categoryFilterSelector = ".fibofilters-block--source--tax_product_cat";

function getCategoryIcons() {
	const filters = window.fiboFiltersData && Array.isArray(window.fiboFiltersData.filters)
		? window.fiboFiltersData.filters
		: [];
	const categoryFilter = filters.find((filter) => filter.source === "tax_product_cat");
	const icons = new Map();

	if (!categoryFilter || !Array.isArray(categoryFilter.values)) {
		return icons;
	}

	categoryFilter.values.forEach((value) => {
		if (value.label && value.smx_thumbnail_url) {
			icons.set(value.label, value.smx_thumbnail_url);
		}
	});

	return icons;
}

function decorateCategoryFilters() {
	const icons = getCategoryIcons();

	if (!icons.size) {
		return;
	}

	document.querySelectorAll(categoryFilterSelector).forEach((filter) => {
		filter.querySelectorAll(".fibofilters-item__interactive").forEach((item) => {
			const label = item.querySelector(".fibofilters-item__label");
			const termLabel = item.getAttribute("title") || (label ? label.textContent.trim() : "");
			const thumbnailUrl = icons.get(termLabel);
			const currentIcon = label ? label.querySelector(".smx-fibofilters-term-icon") : null;

			if (item.dataset.smxCategoryIconReady === "true" && (!thumbnailUrl || currentIcon)) {
				return;
			}

			item.dataset.smxCategoryIconReady = "true";

			if (!label || !thumbnailUrl) {
				return;
			}

			const image = document.createElement("img");
			image.className = "smx-fibofilters-term-icon";
			image.src = thumbnailUrl;
			image.alt = "";
			image.setAttribute("aria-hidden", "true");
			image.loading = "lazy";
			label.prepend(image);
		});
	});
}

function init() {
	let frame = 0;
	const scheduleDecoration = () => {
		window.cancelAnimationFrame(frame);
		frame = window.requestAnimationFrame(decorateCategoryFilters);
	};

	scheduleDecoration();

	const observer = new MutationObserver(scheduleDecoration);
	observer.observe(document.body, { childList: true, subtree: true });
}

export default { init };
